<template>
  <div id="resultado" class="">
    <section class="pt-5">
      <div class="container pt-5">
        <div class="row text-center" v-if="tickets3 != null">
          <div class="col-12 py-4 fXG bold azul">
            ¡Felicidades {{ userProfile.nombre }}!
          </div>
          <p class="col-12 fG bold fXG azul py-5">
            Obtuviste {{ ultimo_ticket.puntos_totales }} puntos
          </p>

          <div class="col-12 col-lg-6 offset-lg-3 azul fG text-center bold">
            <p>
              Recuerda que por cada ticket de compra que registres tienes una
              oportunidad para participar y ganar premios semanales.
            </p>
          </div>

          <div class="col-12 col-lg-6 offset-lg-3 py-5">
            <router-link
              to="/mis-participaciones"
              class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
            >
              Continuar
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import { ticketsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import swal from "sweetalert2";

import * as fb from "../firebase";

import Footer from "@/components/Footer";

const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 27;

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      isRunning: true,
      time: 0,
      time_txt: "",
      suma_puntos: 0,
      suma_time: 0,
      tickets2: [],
      tickets3: null,
      ultimo_ticket: {
        puntos: "",
        time: "",
        time_txt: "",
      },
      ahora: null,
      semana_corriente: "",
    };
  },
  computed: {
    ...mapState(["userProfile", "tickets"]),
  },
  mounted: function () {
    //let en_participacion = this.$store.dispatch('isParticipando')
    console.log({ userProfile: this.userProfile });
    //this.getTickets();
    this.getTickets2();
  },
  methods: {
    async getTickets2() {
      const docs = await ticketsCollection
        .where("user_id", "==", fb.auth.currentUser.uid)
        .get();

      this.tickets3 = [];
      docs.forEach((doc) => {
        let ticket = doc.data();
        ticket.id = doc.id;
        this.tickets3.push(ticket);
      });
      this.tickets3 = this.tickets3.sort(this.custom_sort);
      console.log({ tickets3: this.tickets3 });

      this.setResumen();
    },
    getTiempoFormato(time) {
      return this.secondsToHms(time);
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    async setResumen() {
      if (this.tickets3.length > 0) {
        this.ultimo_ticket = this.tickets3[this.tickets3.length - 1];
      }
      console.log({ ultimo: this.ultimo_ticket });
      console.log({ ultimo_id: this.ultimo_ticket.id });

      await this.getAhora();
      this.semana_corriente = this.getNumSemana(this.ahora);
      //console.log({tengoahora: this.ahora});

      let week = this.getSemana(this.ahora);
      let suma_puntos = 0;
      let suma_time = 0;
      this.tickets3.forEach((element) => {
        //console.log({ elem: element.created_on.seconds });
        let date = moment.unix(element.created_on.seconds).format("L");
        //console.log(date);
        //console.log(moment(date).week());
        let temp_week = moment(date).add(2, "days").week();
        if (week == temp_week) {
          suma_puntos = suma_puntos + parseInt(element.puntos_totales);
          suma_time = suma_time + parseInt(element.time);
        }
      });

      let multiplicador = 1;
      // console.log({ multiplicador: this.tickets });
      console.log({ userProfile: this.userProfile });

      this.suma_puntos = suma_puntos;
      //alert(suma_time)
      this.suma_time = this.secondsToHms(suma_time);
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    getNumSemana(fecha) {
      let semana = parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;
      if (semana == 0) semana = 1;
      return semana;
    },
    getSemana(fecha) {
      return moment(fecha).add(2, "days").week();
    },
    async getAhora() {
      this.$store.dispatch("showLoader", true);
      var thes = this;
      //fb.functions.useFunctionsEmulator('http://localhost:5000')
      var getFecha = fb.functions.httpsCallable("getAhora");

      let res = null;
      await getFecha("{}")
        .then(function (result) {
          // Read result of the Cloud Function.
          console.log({ resultadoGetAhora: result });
          thes.ahora = thes.getFechaFormato(result.data._seconds);
          //console.log({ahora: thes.ahora})
        })
        .catch(function (error) {
          console.log({ errorgetahora: error });
        });

      this.$store.dispatch("showLoader", false);
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
